export default [
  {
    path: '/campaign/overview',
    name: 'see-campaign-overview',
    component: () => import('@/views/see/overview/Index.vue'),
  },
  {
    path: '/media-intelligence/awareness',
    name: 'see-campaign-media-awareness',
    component: () => import('@/views/see/media/awareness/Awareness.vue'),
    children: [
      {
        path: 'overview',
        name: 'see-campaign-media-awareness-overview',
        component: () => import('@/views/see/media/awareness/Index.vue'),
      },
    ],
  },
  {
    path: '/media-intelligence/consideration',
    name: 'see-campaign-media-consideration',
    component: () => import('@/views/see/media/consideration/Consideration.vue'),
    children: [
      {
        path: 'app',
        name: 'see-campaign-media-consideration-app',
        component: () => import('@/views/see/media/consideration/app-traffic/Index.vue'),
      },
      {
        path: 'web',
        name: 'see-campaign-media-consideration-web',
        component: () => import('@/views/see/media/consideration/web-traffic/Index.vue'),
      },
    ],
  },
  {
    path: '/media-intelligence/conversion',
    name: 'see-campaign-media-conversion',
    component: () => import('@/views/see/media/conversion/Index.vue'),
    children: [
      {
        path: 'app',
        name: 'see-campaign-media-conversion-app',
        component: () => import('@/views/see/media/conversion/Index.vue'),
      },
      {
        path: 'web',
        name: 'see-campaign-media-conversion-web',
        component: () => import('@/views/see/media/conversion/Index.vue'),
      },
    ],
  },
  {
    path: '/media-intelligence/smart-optimization',
    name: 'manage-smartOptimization',
    component: () => import('@/views/manage/optimization/Index.vue'),
    children: [
      {
        path: 'technical',
        name: 'manage-smartOptimization-technical',
        component: () => import('@/views/manage/optimization/smart-optimization/Index.vue'),
      },
      {
        path: 'algorithmic',
        name: 'manage-smartOptimization-general',
        component: () => import('@/views/manage/optimization/algorithmic-optimization/Index.vue'),
      },
      {
        path: 'parametric-optimization',
        name: 'manage-smartOptimization-parametricOptimization',
        component: () => import('@/views/manage/optimization/parametric-optimization/Index.vue'),
      },
      {
        path: 'ai-budget-optimizer',
        name: 'manage-smartOptimization-aiBudgetOptimizer',
        component: () => import('@/views/manage/optimization/ai-budget-optimizer/Index.vue'),
      },
    ],
  },
  {
    path: '/creative-intelligence',
    name: 'see-campaign-creative',
    component: () => import('@/views/see/creative/Creative.vue'),
    children: [
      {
        path: 'overview',
        name: 'see-campaign-creative-overview',
        component: () => import('@/views/see/creative/overview/Index.vue'),
      },
      {
        path: 'video',
        name: 'see-campaign-creative-video',
        component: () => import('@/views/see/creative/video/Index.vue'),
      },
    ],
  },
]
